var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-75 h-100 p-0 m-0 mx-auto"},[_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }